import React from 'react';
import './Slide.scss';
import Skeleton from '../Skeleton';

const Slide = (props) => {
  const [currentImage, setCurrentImage] = React.useState(props.image);
  const [isLoaded, setIsLoaded] = React.useState(false);

  React.useEffect(() => {
    // Обновляем состояние для отображения скелетона при смене изображения
    setIsLoaded(false);

    const img = new Image();
    img.src = props.image;
    img.onload = () => {
      setCurrentImage(props.image); // Устанавливаем новое изображение
      setIsLoaded(true); // Показываем изображение после загрузки
    };
  }, [props.image]);

  const paragraphs = props.text.split(/\n+/).filter((paragraph) => paragraph.trim() !== '');
  const additioanlparagraphs =
    props.additionalText &&
    props.additionalText.split(/\n+/).filter((paragraph) => paragraph.trim() !== '');

  return (
    <div className="slide">
      <div className="slide__text-container">
        <div
          className={
            props.additionalText
              ? 'slide__text-content slide__text-content-with-additional'
              : 'slide__text-content'
          }>
          <div>
            {paragraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
            {props.color && <img src={props.color} alt={props.title} />}
          </div>
          <div>
            <span>{props.problem}</span>
            <h3>{props.title}</h3>
          </div>
        </div>
        {props.additionalText && (
          <div
            className={
              props.additionalText
                ? 'slide__text-content slide__text-content-with-additional'
                : 'slide__text-content'
            }>
            <div>
              {additioanlparagraphs.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>
            <div>
              <span>{props.additionalProblem}</span>
              <h3>{props.additionalTitle}</h3>
            </div>
          </div>
        )}
      </div>
      <div className="slide__image-container">
        {!isLoaded && <Skeleton isLoaded={isLoaded} />}
        {currentImage && (
          <img
            src={currentImage}
            alt={props.title}
            className={`slide__image ${isLoaded ? 'loaded' : ''}`}
          />
        )}
      </div>
    </div>
  );
};

export default Slide;
